"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));
var _styles = _interopRequireDefault(require("./styles"));
var _TextField = _interopRequireDefault(require("../../TextField/TextField"));
var _Close = _interopRequireDefault(require("mdi-material-ui/Close"));
var _excluded = ["value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
var LocationInput = props => {
  var {
    onChange,
    isDisabled,
    selectProps,
    inputProps,
    isFocused,
    optionSelected,
    clearField
  } = props;
  var {
    isLoading
  } = selectProps;
  var classes = (0, _styles.default)(props);
  var {
      value
    } = inputProps,
    restInputProps = _objectWithoutProperties(inputProps, _excluded);
  var renderAdornment = () => {
    if (isLoading) return /*#__PURE__*/_react.default.createElement(_CircularProgress.default, {
      size: 20,
      className: classes.loadingIndicator
    });else if (optionSelected) return /*#__PURE__*/_react.default.createElement(_Close.default, {
      onClick: () => clearField(),
      className: classes.clearField
    });else return null;
  };
  var valueProp = {};
  if (value && value.length > 0 && !isFocused) {
    valueProp.value = value;
  }
  return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, restInputProps, valueProp, {
    disabled: isDisabled,
    onChange: onChange,
    endAdornment: renderAdornment()
  }));
};
LocationInput.defaultProps = {
  inputProps: {
    required: false,
    fullWidth: false,
    error: null,
    helperText: ''
  }
};
var _default = exports.default = LocationInput;